(() => {
  const selector = '.product-gallery__image, .product-gallery__thumbnail img, .product-card__image:not(.product-card__image--secondary), .cart-line__image';
  const states = new WeakMap();

  const recover = (image) => {
    if (!(image instanceof HTMLImageElement) || !image.matches(selector)) return;
    let state = states.get(image);
    if (!state) {
      if (!image.getAttribute('src')) return;
      state = { attempts: 0, source: image.currentSrc || image.src, src: image.getAttribute('src'), srcset: image.getAttribute('srcset') };
      states.set(image, state);
    }
    if (state.timer || state.attempts >= 2) {
      if (!state.timer && !state.placeholder) {
        image.dataset.imageState = 'failed';
        state.placeholder = document.createElement('span');
        state.placeholder.className = 'image-recovery__placeholder';
        state.placeholder.textContent = document.body.dataset.imageErrorLabel;
        image.parentElement.classList.add('image-recovery__container');
        image.parentElement.append(state.placeholder);
      }
      return;
    }
    image.dataset.imageState = 'retrying';
    state.attempts += 1;
    state.timer = setTimeout(() => {
      state.timer = null;
      if (!image.isConnected) return;
      const url = new URL(state.source, location.href);
      const width = Number(url.searchParams.get('width')) || image.width || 960;
      url.searchParams.set('width', String(Math.max(90, Math.min(state.attempts === 1 ? 720 : 360, Math.round(width / (state.attempts + 1))))));
      // A smaller CDN variant gives a failed responsive request a separate recovery path.
      image.removeAttribute('srcset');
      image.loading = 'eager';
      image.src = url.href;
    }, state.attempts === 1 ? 250 : 1000);
  };

  const initialize = (root = document) => {
    root.querySelectorAll(selector).forEach((image) => {
      if (image.complete && image.naturalWidth === 0) recover(image);
    });
  };

  document.addEventListener('error', (event) => recover(event.target), true);
  document.addEventListener('load', (event) => {
    const image = event.target;
    if (!(image instanceof HTMLImageElement) || !image.matches(selector)) return;
    const state = states.get(image);
    if (state?.timer) clearTimeout(state.timer);
    state?.placeholder?.remove();
    delete image.dataset.imageState;
    states.delete(image);
  }, true);
  window.addEventListener('online', () => {
    document.querySelectorAll(selector).forEach((image) => {
      if (image.dataset.imageState !== 'failed') return;
      const state = states.get(image);
      state?.placeholder?.remove();
      states.delete(image);
      delete image.dataset.imageState;
      if (state?.srcset) image.setAttribute('srcset', state.srcset);
      image.src = state?.src || image.src;
    });
  });
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
})();
